import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AttachmentType } from 'models/AttachmentType';

interface AttachmentTypeState {
  list: AttachmentType[];
  loading: boolean;
  error: string | null;
}

const initialState: AttachmentTypeState = {
  list: [],
  loading: false,
  error: null,
};

const attachmentTypeSlice = createSlice({
  name: 'attachmentType',
  initialState,
  reducers: {
    setAttachmentTypes(state, action: PayloadAction<AttachmentType[]>) {
      state.list = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const { setAttachmentTypes, setLoading, setError } = attachmentTypeSlice.actions;
export default attachmentTypeSlice.reducer;
